var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11203_10424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9983 22.5613L28.4291 13.9921C27.6394 13.2022 26.5711 12.7542 25.4543 12.7445C24.3375 12.7349 23.2616 13.1644 22.4584 13.9405L13.8892 22.5097C13.0906 23.3083 12.6419 24.3915 12.6419 25.5208C12.6419 26.6502 13.0906 27.7333 13.8892 28.5319L22.4584 37.1012C23.257 37.8998 24.3402 38.3484 25.4695 38.3484C26.5989 38.3484 27.682 37.8998 28.4806 37.1012L37.0499 28.5319C37.826 27.7288 38.2555 26.6529 38.2458 25.5361C38.2362 24.4193 37.7882 23.3509 36.9983 22.5613ZM26.8926 31.3471C26.477 31.7357 25.9256 31.9459 25.3568 31.9324C24.788 31.9189 24.2472 31.6828 23.8505 31.2749L19.5092 26.9336C19.1017 26.5261 18.8728 25.9734 18.8728 25.3971C18.8728 24.8208 19.1017 24.2681 19.5092 23.8606L23.8712 19.4986C24.2787 19.0911 24.8314 18.8622 25.4077 18.8622C25.984 18.8622 26.5366 19.0911 26.9441 19.4986L31.2855 23.84C31.693 24.2475 31.9219 24.8002 31.9219 25.3765C31.9219 25.9528 31.693 26.5055 31.2855 26.913L26.8926 31.3471Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.3129 14.6521L22.0048 19.3441L23.6032 17.7457L18.9112 13.0538C18.7006 12.8432 18.415 12.7249 18.1172 12.7249C17.8194 12.7249 17.5338 12.8432 17.3232 13.0538C17.1116 13.2653 16.9919 13.5517 16.99 13.8508C16.988 14.15 17.104 14.4379 17.3129 14.6521Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.3252 19.0142L33.6872 14.6522C33.896 14.438 34.012 14.1501 34.0101 13.8509C34.0082 13.5517 33.8885 13.2654 33.6769 13.0539C33.5718 12.9487 33.4468 12.8655 33.3092 12.809C33.1717 12.7525 33.0243 12.724 32.8756 12.7249C32.7269 12.7259 32.5798 12.7564 32.443 12.8146C32.3062 12.8728 32.1823 12.9577 32.0785 13.0642L27.7269 17.4158L29.3252 19.0142Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.5727 23.2626L37.9346 18.9006C38.1452 18.69 38.2635 18.4044 38.2635 18.1066C38.2635 17.8088 38.1452 17.5232 37.9346 17.3126C37.7241 17.102 37.4384 16.9837 37.1406 16.9837C36.8428 16.9837 36.5572 17.102 36.3466 17.3126L31.9846 21.6745L33.5727 23.2626Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.9251 29.2644L36.3489 33.6882C36.5632 33.897 36.851 34.013 37.1502 34.0111C37.4494 34.0092 37.7357 33.8895 37.9473 33.6779C38.1579 33.4673 38.2762 33.1817 38.2762 32.8839C38.2762 32.5861 38.1579 32.3004 37.9473 32.0899L33.5234 27.666L31.9251 29.2644Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.6895 36.3486L29.2656 31.9248L27.6776 33.5128L32.1014 37.9367C32.312 38.1473 32.5976 38.2656 32.8954 38.2656C33.1933 38.2656 33.4789 38.1473 33.6895 37.9367C33.9 37.7261 34.0184 37.4405 34.0184 37.1427C34.0184 36.8448 33.9 36.5592 33.6895 36.3486Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19.3453 22.0045L14.6534 17.3126C14.4428 17.102 14.1572 16.9837 13.8594 16.9837C13.5616 16.9837 13.2759 17.102 13.0654 17.3126C12.8548 17.5232 12.7365 17.8088 12.7365 18.1066C12.7365 18.4044 12.8548 18.69 13.0654 18.9006L17.7573 23.5926L19.3453 22.0045Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M21.5898 32.0693L17.3104 36.3488C17.0998 36.5594 16.9815 36.845 16.9815 37.1428C16.9815 37.4406 17.0998 37.7263 17.3104 37.9368C17.521 38.1474 17.8066 38.2657 18.1044 38.2657C18.4022 38.2657 18.6878 38.1474 18.8984 37.9368L23.1779 33.6574L21.5898 32.0693Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.332 27.8101L13.0526 32.0895C12.842 32.3001 12.7237 32.5857 12.7237 32.8835C12.7237 33.1814 12.842 33.467 13.0526 33.6776C13.2641 33.8891 13.5505 34.0088 13.8496 34.0108C14.1488 34.0127 14.4367 33.8967 14.6509 33.6879L18.9304 29.4084L17.332 27.8101Z",
    fill: "#30B3D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11203_10424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(25.5 0.751465) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/Technology.2a5fe27bb1d7a603c652bb347018f21a.svg";
export { ForwardRef as ReactComponent };